import React from 'react';
import { type Dispatch } from 'redux';
import { type TFunction } from 'i18next';
import MobileDetect from 'mobile-detect';
import { DialogContent, DialogTitle, Grid, IconButton, InputAdornment, TextField, Tooltip } from '@mui/material';

import { openDialog } from 'app/store/fuse/dialogSlice';
import { openLink } from '../Utils';
import Icon from '../Icon';
import useSettings from '../hooks/useSettings';

interface ShareProps {
	model: any;
	dispatch: Dispatch<any>;
	settings: any;
	t: TFunction;
}

interface ShareDialogProps {
	title: string;
	body: string;
}

const md = new MobileDetect(window.navigator.userAgent);

export function shareDetailsPage({ model, dispatch, settings, t }: ShareProps) {
	const itemTitle = model[`${settings.modu_short}_title`];
	const companyTitle = settings.modu_title !== 'companies' ? model.comp_title : undefined;

	const title = `${import.meta.env.VITE_TITLE} - ${t(`MODULE_${settings.modu_title}_NAME_SINGULAR`)} "${
		companyTitle ? `${itemTitle} - ${companyTitle}` : itemTitle
	}"`;

	const body = `Link: ${document.URL}\n\n`;

	if (md.mobile()) {
		navigator.share({ title, url: document.URL }).then(() => console.log('Opened WebShare API'));
		// .catch(() => {
		// 	dispatch(showShareDialog({ title, body }));
		// });
	} else {
		dispatch(showShareDialog({ title, body }));
	}
}

export function showShareDialog(props: ShareDialogProps) {
	return openDialog({ children: <ShareDialog {...props} />, maxWidth: 'xs', fullWidth: true });
}

export default function ShareDialog({ title, body }: ShareDialogProps) {
	const { t } = useSettings();

	const [openTooltip, setOpenTooltip] = React.useState(false);

	return (
		<>
			<DialogTitle>{t('DIALOG_TITLE_SHARE')}</DialogTitle>
			<DialogContent>
				<Grid container spacing={1}>
					<Grid size={12}>
						<Tooltip
							open={openTooltip}
							onClose={() => setOpenTooltip(false)}
							title={t('DIALOG_COPIED_ALERT')}
							leaveDelay={700}
							disableInteractive
						>
							<TextField
								label="URL"
								value={document.URL}
								variant="filled"
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												onClick={() => {
													navigator.clipboard.writeText(document.URL);
													setOpenTooltip(true);
												}}
											>
												<Icon icon="content-copy" />
											</IconButton>
										</InputAdornment>
									),
									readOnly: true
								}}
								fullWidth
							/>
						</Tooltip>
					</Grid>
					<Grid>
						<IconButton
							onClick={() => {
								const text = encodeURIComponent(`${title} - ${body}`);
								openLink({ pathname: `https://wa.me/?text=${text}`, newTab: true, external: true });
							}}
						>
							<Icon icon="whatsapp" size={32} />
						</IconButton>
					</Grid>
					{/* <Grid>
						<IconButton
							onClick={() => {
								window.open(`https://twitter.com/messages/compose?text=${path}`);
							}}
						>
							<Icon icon="twitter" size={32} />
						</IconButton>
					</Grid>
					<Grid>
						<IconButton
							onClick={() => {
								window.open(`https://t.me/share/url?text=${path}`);
							}}
						>
							<Icon icon="telegram" size={32} />
						</IconButton>
					</Grid>
					<Grid>
						<IconButton
							onClick={() => {
								window.open(`sms:?body=${path}`);
							}}
						>
							<Icon icon="comment-text-multiple" size={32} />
						</IconButton>
					</Grid> */}
					<Grid>
						<IconButton
							onClick={() => {
								title = encodeURIComponent(title);
								body = encodeURIComponent(body);
								openLink({ pathname: `mailto:?subject=${title}&body=${body}`, external: true });
							}}
						>
							<Icon icon="email" size={32} />
						</IconButton>
					</Grid>
				</Grid>
			</DialogContent>
		</>
	);
}
